<template>
  <v-card flat>
    <v-card-subtitle class="px-0 font-weight-bold">{{ title }}</v-card-subtitle>
    <v-card-text class="px-0">
      <v-text-field
        hide-details="auto"
        class="text-uppercase"
        outlined
        dense
        v-model="color"
        clearable
        type="text"
        @click="display = true"
      >
        <template v-slot:prepend-inner>
          <!--<v-icon v-if="color" :color="color" :style="{ border: '1px solid #ccc', borderRadius: '4px' }" @click="display = true">mdi-square-rounded</v-icon>-->
          <div
            class="color-preview"
            :class="{ 'color-preview--empty': !color }"
            :style="{ backgroundColor: color }"
            @click="display = true"
          />
        </template>
      </v-text-field>
    </v-card-text>
    <YesNoDialog v-model="display" :title="title" @validate="validate">
      <template v-slot:content>
        <div class="d-flex justify-center align-center">
          <v-color-picker
            dot-size="25"
            hide-mode-switch
            :mode="colorMode"
            swatches-max-height="200"
            v-model="pickedColor"
            @update:color="updateColor"
          />
        </div>
      </template>
    </YesNoDialog>
  </v-card>
</template>

<script>
  import { textExists } from '../../helpers/helper'
  import YesNoDialog from '../dialogs/YesNoDialog.vue'

  export default {
    name: 'ColorSelector',
    components: {
      YesNoDialog,
    },
    props: {
      value: {
        type: String,
        default: undefined,
      },
      default: {
        type: String,
        default: undefined,
      },
      title: {
        type: String,
        required: true,
      },
      colorMode: {
        type: String,
        default: 'hexa',
      },
      returnColorMode: {
        type: String,
        default: 'hex',
      },
    },
    data() {
      return {
        tempColor: null,
        display: false,
      }
    },
    computed: {
      color: {
        get() {
          return this.value || this.default
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      pickedColor: {
        get() {
          return this.tempColor
        },
        set(value) {
          if (typeof value === 'string') {
            this.tempColor = value
          } else {
            this.tempColor = value[this.returnColorMode]
          }
        },
      },
    },
    watch: {
      display(newValue) {
        if (newValue) {
          this.tempColor = this.color || '#FFFFFF'
        } else {
          this.tempColor = null
        }
      },
    },
    methods: {
      validate() {
        if (!textExists(this.tempColor)) {
          return false
        }
        this.color = this.tempColor
        this.display = false
        return true
      },
      updateColor(color) {
        this.pickedColor = color[this.returnColorMode]
      },
    },
  }
</script>

<style scoped>
  .color-preview {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.23);
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .color-preview--empty {
    background: repeating-linear-gradient(45deg, #f5f5f5, #f5f5f5 2px, #e0e0e0 2px, #e0e0e0 4px);
  }

  .color-preview:hover {
    border-color: rgba(0, 0, 0, 0.87);
    transform: scale(1.1);
  }
</style>
